// extracted by mini-css-extract-plugin
export default {"currencySymbolClass":"index_currencySymbolClass__GhmEh","priceClass":"index_priceClass__UdgA+","noPrice":"index_noPrice__cyOKt"};